import { GET_PARAMETRE_DEGER } from "../constants/requestUrls";
import { getRequest } from "../request";

const getParametreDeger = (parameterKey) => {
    return getRequest({url:GET_PARAMETRE_DEGER+"?parameterKey="+parameterKey});
}

export default getParametreDeger;